import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HotelService } from '../services/hotel.service';
import { RoomService } from '../services/room.service';
import { GrowlerService } from '../services/growler.service';
import { RatePlanService } from '../services/rate-plan.service';

@Component({
    selector: 'app-rate-plan-map',
    templateUrl: './rate-plan-map.component.html',
    styleUrls: ['./rate-plan-map.component.css']
})
export class RatePlanMapComponent implements OnInit {
    @Input() ratePlan;
    @Output() complete = new EventEmitter();


    dataToEdit;
    errorString = '';

    hotels = [];
    rooms = [];

    data = {
        id: '',
        tmpId: '',
        ratePlanCode: '',
        name: '',
        description: '',
        overview: '',
        terms: '',
        upsellText: '',
        status: 1,
        allowPassport: 0,
        images: [],
        bannerImage: '',
        hotel: '',
        hotels: [],
        rooms: [],
        isDerivative: 0,
        allowAdditionalNights: false,
        additionalNightDiscount: 0,
        planDiscount: 0,
        planSurcharge: 0,
        additionalNightsTitle: '',
        additionalNightsSubtitle: '',
        allowOpenTable: 1,
    };

    constructor(
        private hotelService: HotelService,
        private roomService: RoomService,
        private growlerService: GrowlerService,
        private ratePlanService: RatePlanService,

    ) { }


    ngOnInit() {
        console.log(this.ratePlan)
        this.getHotels();

        this.get()
    }

    getHotels() {
        this.hotelService.allLite().subscribe(data => {
            this.hotels = data;
        })
    }

    getRooms(killSelection) {
        this.roomService.byHotelID(this.data.hotel).subscribe(data => {

            if (killSelection) {
                this.data.rooms = [];
            }

            this.rooms = [];
            data.data.forEach(r => {
                this.rooms.push({ id: r.id, name: r.name })
            });
        })
    }
    get() {
        this.ratePlanService.get(this.ratePlan.id).subscribe(data => {
            console.log(data);
            this.data = data;
            this.getRooms(false)
        })
    }

    save() {
        this.errorString = '';

        this.ratePlanService.updateMapping(this.data).subscribe(data => {
            this.growlerService.notification(['Rate plan updated']);
        })
    }

    isRoomSelected(id) {
        return this.data.rooms.indexOf(id);
    }

    toggleRoom(id) {
        if (this.isRoomSelected(id) < 0) {
            this.data.rooms.push(id);
        } else {
            this.data.rooms.splice(this.isRoomSelected(id), 1)
        }
    }


    close() {
        this.complete.emit({ action: false });
    }

}
